// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDeclineReasonTypeWithData
 */
export interface IDeclineReasonTypeWithData {
    /**
     * 
     * @type {string}
     * @memberof IDeclineReasonTypeWithData
     */
    reason_type?: IDeclineReasonTypeWithDataReasonTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IDeclineReasonTypeWithData
     */
    json_data?: string;
}

/**
* @export
* @enum {string}
*/
export enum IDeclineReasonTypeWithDataReasonTypeEnum {
    GENERIC = 'GENERIC',
    NOT_ACTIVATED = 'NOT_ACTIVATED',
    CARD_LOCKED = 'CARD_LOCKED',
    CARD_LOST = 'CARD_LOST',
    CARD_EXPIRED = 'CARD_EXPIRED',
    PIN_REQUIRED = 'PIN_REQUIRED',
    NO_AVAILABLE_BALANCE = 'NO_AVAILABLE_BALANCE',
    NOT_ENOUGH_BALANCE = 'NOT_ENOUGH_BALANCE',
    NOT_ALLOWED_SERVICE_FOR_PLAN = 'NOT_ALLOWED_SERVICE_FOR_PLAN',
    NOT_HEALTHCARE_SERVICE = 'NOT_HEALTHCARE_SERVICE',
    PRIOR_TO_PLAN_START_DATE = 'PRIOR_TO_PLAN_START_DATE',
    PAST_PLAN_END_DATE = 'PAST_PLAN_END_DATE',
    CVS_NOT_ALLOWED = 'CVS_NOT_ALLOWED',
    PIN_INVALID = 'PIN_INVALID',
    ORG_LOCKED = 'ORG_LOCKED',
    OVERLIMIT = 'OVERLIMIT',
    PEND_CONTRIBUTIONS = 'PEND_CONTRIBUTIONS',
    PEND_CONTRIBUTIONS_AND_CIP = 'PEND_CONTRIBUTIONS_AND_CIP',
    DATA_ENTERED_INCORRECTLY = 'DATA_ENTERED_INCORRECTLY',
    TEMPORARY_BLOCKED_MERCHANT = 'TEMPORARY_BLOCKED_MERCHANT',
    PERMANENTLY_BLOCKED_MERCHANT = 'PERMANENTLY_BLOCKED_MERCHANT',
    TERMINATED_EMPLOYEE = 'TERMINATED_EMPLOYEE',
    ORPHANED_EMPLOYEE = 'ORPHANED_EMPLOYEE',
    TERMINATED_EMPLOYER = 'TERMINATED_EMPLOYER',
    LOCKED_CARD_PURSE = 'LOCKED_CARD_PURSE'
}


/**
 * Check if a given object implements the IDeclineReasonTypeWithData interface.
 */
export function instanceOfIDeclineReasonTypeWithData(value: object): value is IDeclineReasonTypeWithData {
    return true;
}

export function IDeclineReasonTypeWithDataFromJSON(json: any): IDeclineReasonTypeWithData {
    return IDeclineReasonTypeWithDataFromJSONTyped(json, false);
}

export function IDeclineReasonTypeWithDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDeclineReasonTypeWithData {
    if (json == null) {
        return json;
    }
    return {
        
        'reason_type': json['reason_type'] == null ? undefined : json['reason_type'],
        'json_data': json['json_data'] == null ? undefined : json['json_data'],
    };
}

export function IDeclineReasonTypeWithDataToJSON(json: any): IDeclineReasonTypeWithData {
    return IDeclineReasonTypeWithDataToJSONTyped(json, false);
}

export function IDeclineReasonTypeWithDataToJSONTyped(value?: IDeclineReasonTypeWithData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason_type': value['reason_type'],
        'json_data': value['json_data'],
    };
}

